<div class="td-wb-side-sheet-selector-item__data">
  <ng-content />
</div>
